'use client';

import * as React from 'react';
import { useContext, useState } from 'react';
import Button, { ButtonTheme } from '@/components/ui/Button';
import { AuthContext, getUserOrder } from '@/components/auth/AuthProvider';
import { useOverlay } from '@/components/hooks/useOverlay';
import { OverlayKey } from '@/lib/enums/overlayKey.enum';
import OverlayAddDebt from '@/components/overlays/AddDebt';
import AddDebtNotLoggedInPaywall from '@/components/overlays/AddDebtNotLoggedInPaywall';
import AddDebtPaywall from '@/components/overlays/AddDebtPaywall';

interface IProps {
  title: string;
  theme?: ButtonTheme;
}

const CompanyAddDebtButton: React.FunctionComponent<IProps> = (props) => {
  const { openOverlay } = useOverlay(OverlayKey.lisa_volg);
  const { openOverlay: openNotLoggedInDebtPaywall } = useOverlay(OverlayKey.not_logged_in_debt_paywall);
  const { openOverlay: openNoAccessDebtPaywall } = useOverlay(OverlayKey.lisa_volg_paywall);
  const { jwt } = useContext(AuthContext);
  const [hasAccess, setHasAccess] = useState(false);

  const onCompanyAddDebtClick = async () => {
    if (hasAccess) {
      openOverlay();
      return;
    }

    if (!jwt) {
      openNotLoggedInDebtPaywall();
      return;
    }

    const userOrder = await getUserOrder(jwt);
    if (userOrder?.orderCode) {
      setHasAccess(true);
      openOverlay();
    } else {
      openNoAccessDebtPaywall();
    }
  };

  return (
    <React.Fragment>
      <Button
        title={props.title}
        onClick={() => void onCompanyAddDebtClick()}
        size="large"
        theme={props.theme}
      />
      <OverlayAddDebt hasCompanyAutocompleteAccess={hasAccess} />
      <AddDebtNotLoggedInPaywall />
      <AddDebtPaywall />
    </React.Fragment>
  );
};

CompanyAddDebtButton.displayName = 'ButtonAddDebt';

export default CompanyAddDebtButton;
